import React from 'react'

export default function listStyles(appProps, itemsPerRow = null) {
  const rentalItems = itemsPerRow ? itemsPerRow : appProps.rentalsPerListLine

  if (rentalItems == 1) {
    return `
      .rental-list-items .rental-item {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
      }
      .rental-list-items .rental-item .rental-image {
        width: 100%;
      }
      .rental-item .rental-details {
        width: 65%;
      }
      @media screen and (min-width: 550px) {
        .rental-list-items .rental-item .rental-image {
          width: 100%;
        }
        .rental-item .rental-details {
          width: 70%;
        }
      }
    `

  } else if (rentalItems == 2) {
    return `
      @media screen and (min-width:600px) {
        .rental-list-items .rental-item {
          width: calc( 95% / 2 );
          margin-right: calc( 5% / 2 );
        }
        .rental-list .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }
    `

  } else if (rentalItems == 3) {
    return `
      @media screen and (min-width:600px) {
        .rental-list-items .rental-item {
          width: calc( 95% / 2 );
          margin-right: calc( 5% / 2 );
        }
        .rental-list .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }

      @media screen and (min-width:750px) {
        .rental-list-items .rental-item {
          width: calc( 95% / 3 );
          margin-right: calc( 5% / 3 );
        }
        .rental-list .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }
    `

  } else if (rentalItems == 4) {
    return `
      @media screen and (min-width:410px) {
        .rental-list-items .rental-item {
          width: calc( 95% / 2 );
          margin-right: calc( 5% / 2 );
        }
        .rental-list .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }

      @media screen and (min-width:750px) {
        .rental-list-items .rental-item {
          width: calc( 95% / 3 );
          margin-right: calc( 5% / 3 );
        }
        .rental-list .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }

      @media only screen and (min-width: 800px) {
        .rental-list-items .rental-item {
          width: calc( 95% / 4 );
          margin-right: calc( 5% / 4 );
        }
        .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }
    `

  } else if (rentalItems == 5) {
    return `
      @media screen and (min-width:600px) {
        .rental-list .rental-list-items .rental-item {
          width: calc( 95% / 2 );
          margin-right: calc( 5% / 2 );
        }
        .rental-list .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }

      @media screen and (min-width:750px) {
        .rental-list .rental-list-items .rental-item {
          width: calc( 95% / 3 );
          margin-right: calc( 5% / 3 );
        }
        .rental-list .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }

      @media screen and (min-width:800px) {
        .rental-list .rental-list-items .rental-item {
          width: calc( 95% / 4 );
          margin-right: calc( 5% / 4 );
        }
        .rental-list .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }

      @media screen and (min-width:1000px) {
        .rental-list .rental-list-items .rental-item {
          width: calc( 95% / 5 );
          margin-right: calc( 5% / 5 );
        }
        .rental-list .rental-list-items .rental-item:last-child {
          margin-right: 0px;
        }
      }
    `
  }

  return ''
}
